import { Form } from "antd";

import type { FieldMethod, FormFieldFactoryProps } from "../../types/types";
import { Checkbox } from "../index";

export const CheckboxField: FieldMethod = ({ field, readOnly, rules }: FormFieldFactoryProps) => {
    return (
        <Form.Item key={`${field.name}FormItem`} name={field.name} rules={rules}>
            <Checkbox key={field.name} name={field.name} readOnly={readOnly} label={" "} />
        </Form.Item>
    );
};
